const debounce = require('debounce')

export default {
  mounted() {
    this.__resizeHandler = debounce(() => {
      if (this.chart) {
        this.chart.resize()
      }
    }, 100)

    window.addEventListener('resize', this.__resizeHandler)
  },
  beforeDestory() {
    window.removeEventListener('resize', this.__resizeHandler)
  },
  computed: {
    navbarStatus() {
      return this.$store.state.app.navbarExpand
    }
  },
  watch: {
    navbarStatus() {
      setTimeout(() => {
        this.chart.resize()
      }, 100)
    }
  },
  methods: {}
}
